import React from "react";
import {Image} from "react-native";

export default function Alert({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_editable_re_4l94.svg')} />
}

